import { useEffect, useRef } from "react";
import {
  pushOverlay,
  popOverlay,
  isTopOverlay,
  lockBodyScroll,
  unlockBodyScroll,
} from "@/lib/overlay-stack";

// Shared behavior for portaled overlays: registers in the overlay stack,
// closes on Escape only when topmost, and refcounts the body scroll lock.
export function useOverlay(open: boolean, onClose: () => void) {
  const idRef = useRef(Symbol("overlay"));

  useEffect(() => {
    if (!open) return;
    const id = idRef.current;
    pushOverlay(id);
    lockBodyScroll();
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isTopOverlay(id)) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      popOverlay(id);
      unlockBodyScroll();
    };
  }, [open, onClose]);
}
